<style>
  .time-row, .text-input, textarea {
    font-size: 16px;
    margin-left: 0px !important;
    margin-bottom: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 8px;
    border: 1px solid gray;
  }

  .save-button-container {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
  }

  .custom-accordion .mat-expansion-panel {
    border: 2px solid lightgrey !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    margin-bottom: 20px;
  }

  mat-select.select-hours, mat-select.select-vat, textarea {
    padding: 9px !important;
    border: 1px solid gray !important;
  }

  .mat-form-field-label {
    margin-left: 10px !important;
  }

  textarea:focus, input:focus {
    caret-color: black;
  }

  .segment {
    margin-bottom: 20px;
  }

  .invoicegroup {
    margin-bottom: 20px;
  }

  .angular-with-newlines {
    white-space: pre-wrap;
  }

  .receiver {
    border: 2px solid black;
    margin-bottom: 10px;
    padding: 15px;
  }

  .border {
    border: 1px solid black;
    margin: 10px 0 10px 0;
    padding: 15px;
  }

  .deduction {
    border: solid 1px lightgrey;
    margin: 10px 0 0 0;
    padding: 10px 10px;
  }

  .currency {
    float: right;
    position: relative;
    top: 28px;
  }

  .inputwidth {
    width: 30%;
  }

  .default-theme .mat-form-field-appearance-legacy .mat-form-field-underline {
    background-color: rgba(0, 0, 0, 0.1) !important;
  }

  .error {
    color: red;
    font-size: 80%;
  }

</style>
<div *ngIf="!invoiceReady" style="padding: 24px;">
  <div *ngIf="!loadError" role="status" aria-live="polite">
    <mat-spinner [diameter]="32"></mat-spinner>
    <p>Laddar fakturans adminvy...</p>
  </div>
  <p *ngIf="loadError" role="alert">Fakturan kunde inte hämtas. Stäng dialogen och försök igen.</p>
  <button mat-button mat-dialog-close>Stäng</button>
</div>
<div class="container" *ngIf="invoiceReady">
  <div style='height:100%;'>
    <div class="row segment" *ngIf="data.Customer != undefined">
      <div *ngIf="data?.CreditInvoiceFor != null && data.CreditInvoiceFor != ''" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Detta är en kreditfaktura för faktura nr {{data?.CreditInvoiceFor}}</b><br />
      </div>
      <div *ngIf="data?.SubInvoice" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Detta är en underfaktura</b><br />
      </div>
      <div *ngIf="data?.ParentInvoice" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Detta är en moderfaktura</b><br />
      </div>
      <div *ngIf="data.SalaryShares != null && data.SalaryShares.length > 0" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns en lönedelning på denna faktura</b><br />
      </div>
      <div *ngIf="data?.User?.AccountSettings?.TaxAdjustments.length != 0 && data?.User?.AccountSettings?.TaxAdjustments.length > 0" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns en skattejämkning/skatteändring på medlemmen</b><br />
      </div>
      <!--<div *ngIf="data?.User?.AccountSettings?.AttachmentOfSalaries.length != 0 && data?.User?.AccountSettings?.AttachmentOfSalaries.length > 0" class="col-12" style="margin-bottom: 10px;">
    <b style="color: red;">Det finns en löneutmätning på medlemmen</b><br />
  </div>-->
      <div *ngIf="data.IsRotRut != null && data.IsRotRut" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns ROT/RUT på denna faktura</b><br />
      </div>
      <div *ngIf="data.IsRut != null && data.IsRut" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns RUT på denna faktura</b><br />
      </div>
      <div *ngIf="data.IsRot != null && data.IsRot" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns ROT på denna faktura</b><br />
      </div>
      <div *ngIf="data?.Type?.TechnicalName == 'ProformaSubInvoice' || data?.Type?.TechnicalName == 'ProformaSingleInvoice'" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Detta är en proforma-faktura</b><br />
      </div>
      <div *ngIf="data?.UserSettings?.Suspended" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Medlemmen är avstängd</b><br />
      </div>
      <div *ngIf="UnhandledDeductions" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns ohanterade utlägg</b><br />
      </div>
      <div *ngIf="hasActiveWageGarnishment && hasUnhandledGarnishableDeductions" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Det finns nettosättningar utan beslut om utmätningsbarhet</b><br />
      </div>
      <div *ngIf="data.ReverseTax" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Omvänd skattskyldighet</b><br />
      </div>      
      <div *ngIf="data.Status?.TechnicalName == 'OfferingRequested'" class="col-12" style="margin-bottom: 10px;">
        <b style="color: red;">Offert begärd</b><br />
      </div>
      <div class="col-lg-12 col-sm-12" style="margin-bottom: 10px;">
        <mat-checkbox matInput [ngModel]="data?.Inactive" (change)="changeValueInactive($event)" id="inactive" name="suspended">Fakturan är inaktiverad (syns ej hos medlem)</mat-checkbox>
      </div>

      <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12">
        <mat-label>Info om fakturan som bara admin ser</mat-label>
        <input matInput [(ngModel)]="data.AdminInfo" value="{{data?.AdminInfo}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12" *ngIf="data?.UserSettings?.AdminInfo != null">
        <mat-label>Info om medlem som bara admin ser</mat-label>
        <input matInput readonly value="{{data?.UserSettings?.AdminInfo}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12" *ngIf="data?.Customer?.PublicInfo || data?.CustomerCopy?.PublicInfo">
        <mat-label>Info om kund som visas för medlem:</mat-label>
        <input matInput readonly [value]="data?.Customer?.PublicInfo || data?.CustomerCopy?.PublicInfo">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12" *ngIf="data?.Customer?.AdminInfo || data?.CustomerCopy?.AdminInfo">
        <mat-label>Info om kund som bara admin ser:</mat-label>
        <input matInput readonly [value]="data?.Customer?.AdminInfo || data?.CustomerCopy?.AdminInfo">
      </mat-form-field>

      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Medlems.nr:</mat-label>
        <input matInput readonly value="{{data?.UserSettings?.MemberNumber}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Anställnings.nr:</mat-label>
        <input matInput readonly value="{{data?.UserSettings?.EmploymentNumber}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Kund:</mat-label>
        <input matInput readonly value="{{data?.Customer?.Name}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Org.nr/p.nr:</mat-label>
        <input matInput readonly value="{{data?.Customer?.OrgNumber}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Fakturadatum:</mat-label>
        <input matInput readonly value="{{data?.InvoiceSentByUser | swedishDate: 'yyyy-MM-dd'}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Förfallodatum:</mat-label>
        <input matInput readonly value="{{data?.PaymentDue | swedishDate: 'yyyy-MM-dd'}}">
      </mat-form-field>

      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Betalningsvillkor:</mat-label>
        <input matInput readonly value="{{data?.PaymentTerm}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Fakturamärkning:</mat-label>
        <input matInput readonly value="{{data?.Marking}}">
      </mat-form-field>

      <mat-form-field floatLabel="always" *ngIf="!organizationSender" class="col-lg-6 col-sm-12">
        <mat-label>Valt visningsnamn:</mat-label>
        <input matInput readonly value="{{data?.UserSettings?.DisplayName}}">
      </mat-form-field>

      <mat-form-field floatLabel="always" *ngIf="!organizationSender" class="col-lg-6 col-sm-12">
        <mat-label>Fullständigt namn:</mat-label>
        <input matInput readonly value="{{data?.UserSettings?.FirstName}} {{data?.UserSettings?.LastName}}">
      </mat-form-field>

      <mat-form-field floatLabel="always" *ngIf="organizationSender" class="col-lg-6 col-sm-12">
        <mat-label>Företag:</mat-label>
        <input matInput readonly value="{{data?.Organization?.Company?.Name}}">
      </mat-form-field>

      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Kundreferens för fakturan:</mat-label>
        <input matInput readonly value="{{data?.Reference?.Name}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Kundreferensens email:</mat-label>
        <input matInput readonly value="{{data?.Reference?.Email}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Elektronisk referens:</mat-label>
        <input matInput readonly value="{{data?.ReferenceText}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Valuta:</mat-label>
        <input matInput readonly value="{{data?.Currency?.Name}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Kundtyp (företag/privat):</mat-label>
        <input matInput readonly value="{{data?.Customer?.IsCompany ? 'Företag' : 'Privat'}}">
      </mat-form-field>
      <div class="col-lg-6 col-sm-12">

      </div>
      <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12">
        <mat-label>Kund:</mat-label>
        <input matInput readonly value="{{data?.Customer?.Name}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12">
        <mat-label>Fakturaadress:</mat-label>
        <input matInput readonly value="c/o: {{data?.Customer?.Co}}">
        <input matInput readonly value="{{data?.Customer?.Address}}">
        <input matInput readonly value="{{data?.Customer?.Address2}}">

      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Postnr:</mat-label>
        <input matInput readonly value="{{data?.Customer?.Zip}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Ort:</mat-label>
        <input matInput readonly value="{{data?.Customer?.City}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Land:</mat-label>
        <input matInput readonly value="{{data?.Customer?.Country?.Name}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>Telefon till företaget:</mat-label>
        <input matInput readonly value="{{data?.Customer?.Phone}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
        <mat-label>E-postadress:</mat-label>
        <input matInput readonly value="{{data?.Customer?.Email}}">
      </mat-form-field>
      <mat-form-field floatLabel="always" *ngIf="data?.Customer.GlnNumber != null && data?.Customer.GlnNumber != ''" class="col-lg-12 col-sm-12">
        <mat-label>GLN-nummer:</mat-label>
        <input matInput readonly value="{{data?.Customer?.GlnNumber}}">
      </mat-form-field>
      <div class="col-lg-6 col-sm-12">
        <button mat-stroked-button (click)="editCustomer(data.Customer)" [disabled]="isLoading">Redigera kund</button>
      </div>

      <div class="col-12">
        <h4>Vad ska faktureras:</h4>

        <!-- Om det är en parent invoice, använd en accordion -->
        <mat-accordion class="custom-accordion" *ngIf="data.ParentInvoice">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Fakturerade grupper
              </mat-panel-title>
              <mat-panel-description>
                Klicka för att visa/dölja detaljer
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div *ngFor="let group of data.InvoiceGroups" class="receiver">
              <div *ngIf="hasInvoiceGroupType(group)" style="display:flex; justify-content:flex-end; font-size:80%; font-style:italic; margin-bottom:8px;">
                <span>{{getInvoiceGroupTypeLabel(group)}}</span>
              </div>
              <div *ngIf="data.ParentInvoice">
                <b>Mottagare:</b>
                <span *ngIf="!group?.PaymentReciever?.IsCompany">
                  {{group?.PaymentReciever?.FirstName}} {{group?.PaymentReciever?.LastName}} - {{group?.PaymentReciever?.PersonalNumber}}
                </span>
                <span *ngIf="group?.PaymentReciever?.IsCompany">
                  {{group?.PaymentReciever?.CompanyName}} - {{group?.PaymentReciever?.OrgNumber}}
                </span><br />
                <span *ngIf="group?.EmploymentType != null && !group?.PaymentReciever?.IsCompany">
                  ({{group?.EmploymentType?.Name}})
                </span>
                <span *ngIf="group?.PaymentReciever?.IsCompany">(Företag/konsult)</span>
              </div>
              <div *ngIf="group.PensionSavingsAmount > 0">
                <b>Pension inkl skatt:</b><br />
                {{group.PensionSavingsAmount * 1.2426 | number : '1.0-0'}}<br />
              </div>

              <ng-container *ngIf="!isWorkedHoursGroup(group); else workedHoursParentGroup">
                <b>Moms:</b><br />
                {{group?.Vat}} % <span *ngIf="data.ReverseTax || group.ReverseTax">(omvänd skattskyldighet)</span><br />
                <b>Beskrivning:</b><br />
                <span class="angular-with-newlines">{{addLinebreaks(255, group.Description)}}</span><br />
                <b>Summa:</b><br />
                {{group.Amount}} {{data?.Currency?.Name}}<br />
                <ng-container *ngIf="!isInvoiceItemGroup(group)">
                  <b>Visa på faktura:</b><br />
                  <span class="angular-with-newlines">{{group?.TimeReportStatus?.DisplayName}}</span><br />
                </ng-container>
              </ng-container>
              <ng-template #workedHoursParentGroup>
                <!--<b>Arbetad tid</b>--><br />
                <ng-container *ngIf="shouldShowTimeReportStatus(group)">
                  <b>Visa på faktura:</b><br />
                  <span class="angular-with-newlines">{{group?.TimeReportStatus?.DisplayName}}</span><br />
                </ng-container>
              </ng-template>
              <div *ngIf="group.TimeReportStatus.Name == 'SumTime'">
                {{group?.InvoiceRows[0]?.StartDate | swedishDate: 'yyyy-MM-dd'}} -
                {{group?.InvoiceRows[group.InvoiceRows.length-1]?.StartDate | swedishDate: 'yyyy-MM-dd'}} ({{getGroupTotalHours(group)}})
              </div>
              <div *ngIf="group.TimeReportStatus.Name == 'DetailedInfo'">
                <span *ngFor="let row of group.InvoiceRows; let i = index">
                  {{row?.StartDate | swedishDate: 'yyyy-MM-dd'}} ({{row?.HoursWorked}} h{{row?.MinutesWorked > 0 ? ' ' + row?.MinutesWorked.toString() + ' min' : ''}}),
                  <br *ngIf="i > 0 && (i + 1) % 4 == 0" />
                </span>
              </div>

              <!-- Utlägg (Avdrag) -->
              <div *ngIf="group.Deductions?.length > 0" class="border">
                <h4>Avdrag:</h4>
                <div *ngFor="let deduction of group.Deductions" class="deduction">
                  <h4>{{deduction?.Name}}</h4>
                <b>Belopp enligt kvitto:</b><br />
                {{deduction?.Amount | number : '1.2-2'}} SEK<br />
                  <ng-container *ngIf="deduction?.AddedToInvoice">
                    <b>Faktureras kund:</b><br />
                    {{(deduction?.AgreedInvoiceAmount != null ? deduction?.AgreedInvoiceAmount : deduction?.Amount) | number : '1.2-2'}} SEK<br />
                  </ng-container>
                  <b>Beskrivning:</b><br />
                  <span class="angular-with-newlines">{{addLinebreaks(50, deduction?.Description)}}</span><br />
                  <div *ngIf="hasActiveWageGarnishment" class="row" style="margin-top: 10px;">
                    <div class="col-lg-4">
                      <div style="font-weight: 600;">Löneutmätning</div>
                    </div>
                    <div class="col-lg-8">
                      <mat-radio-group [ngModel]="deduction.IsGarnishable" (ngModelChange)="changeDeductionGarnishableStatus(deduction, $event)" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                        <mat-radio-button style="margin-right: 10px;" [value]="true">Utmätningsbar</mat-radio-button>
                        <mat-radio-button [value]="false">Ej utmätningsbar</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
              </div>

              <!--Reseersättning-->
              <div *ngIf="group.Allowances?.length > 0" class="border">
                <h4>Reseersättning:</h4>
                <div *ngFor="let allowance of group.Allowances" class="deduction">
                  <h4>{{allowance.AllowanceType.Name}}</h4>
                  Skattefri reseersättning: {{allowance.Sum | number : '1.2-2'}} SEK <br />
                  <div *ngIf="allowance.Mileage > 0">
                    <div *ngIf="allowance.AddedToInvoice">Faktureras kund: {{ (allowance.CustomReimbursementPerKm !== 0 && allowance.sumCustomReimbursementPerKm ? allowance.sumCustomReimbursementPerKm : allowance.Sum) | number : '1.2-2' }} SEK</div>
                    <div>{{allowance.Mileage}} km</div><br />
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <mat-radio-group [(ngModel)]="allowance.status" (change)="changeAllowanceStatus(allowance, $event.value)" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                        <mat-radio-button style="margin-right: 10px;" value="underReview">Granskas</mat-radio-button>
                        <mat-radio-button style="margin-right: 10px;" value="approved">Reseersättning godkänd</mat-radio-button>
                        <mat-radio-button value="denied">Reseersättning ej godkänd</mat-radio-button>
                      </mat-radio-group>
                    </div>
                    <div *ngIf="hasActiveWageGarnishment" class="col-lg-12" style="margin-top: 10px;">
                      <div class="row">
                        <div class="col-lg-4">
                          <div style="font-weight: 600;">Löneutmatning</div>
                        </div>
                        <div class="col-lg-8">
                          <mat-radio-group [ngModel]="allowance.IsGarnishable" (ngModelChange)="changeAllowanceGarnishableStatus(allowance, $event)" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                            <mat-radio-button style="margin-right: 10px;" [value]="true">Utmatningsbar</mat-radio-button>
                            <mat-radio-button [value]="false">Ej utmatningsbar</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="sp-form-field-label" style="margin-top: 10px;">Kommentar som syns för medlem:</div>
                      <input [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0" type="text" style="margin: 10px 0; padding: 5px; border: 1px solid lightgrey; width: 100%;" [(ngModel)]="allowance.DeniedReason" matInput />
                      <div *ngIf="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0" style="margin: 10px 0; font-style: italic;">
                        Denna faktura är redan delad, och underlaget finns i underfakturan tillhörande {{data?.UserSettings?.FirstName}} {{data?.UserSettings?.LastName}}. Om informationen om denna reseersättning är felaktig måste detta ändras där.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- Om det INTE är en parent invoice, visa fakturagrupper som vanligt -->
          <div *ngIf="!data.ParentInvoice">
          <div *ngFor="let group of getSortedInvoiceGroups()" class="border">
            <div *ngIf="hasInvoiceGroupType(group)" style="display:flex; justify-content:flex-end; font-size:80%; font-style:italic; margin-bottom:8px;">
                <span>{{getInvoiceGroupTypeLabel(group)}}</span>
              </div>
            <!--<b>Mottagare:</b>
      <span *ngIf="!group?.PaymentReciever?.IsCompany">
        {{group?.PaymentReciever?.FirstName}} {{group?.PaymentReciever?.LastName}} - {{group?.PaymentReciever?.PersonalNumber}}
      </span>
      <span *ngIf="group?.PaymentReciever?.IsCompany">
        {{group?.PaymentReciever?.CompanyName}} - {{group?.PaymentReciever?.OrgNumber}}
      </span><br />-->

            <div *ngIf="group.PensionSavingsAmount > 0">
              <b>Pension inkl skatt:</b><br />
              {{group.PensionSavingsAmount * 1.2426 | number : '1.0-0'}}<br />
            </div>
            <ng-container *ngIf="!isWorkedHoursGroup(group); else workedHoursChildGroup">
              <b>Moms:</b><br />
              {{group?.Vat}} % <span *ngIf="data.ReverseTax || group.ReverseTax">(omvänd skattskyldighet)</span><br />

              <b>Beskrivning:</b><br />
              <span class="angular-with-newlines">{{addLinebreaks(255, group.Description)}}</span><br />
              <b>Summa:</b><br />
              {{group.Amount}} {{data?.Currency?.Name}}<br />

              <ng-container *ngIf="!isInvoiceItemGroup(group) && shouldShowTimeReportStatus(group)">
                <b>Visa på faktura:</b><br />
                <span class="angular-with-newlines">{{group?.TimeReportStatus?.DisplayName}}</span><br />
              </ng-container>
            </ng-container>
            <ng-template #workedHoursChildGroup>
              <ng-container *ngIf="shouldShowTimeReportStatus(group)">
                <b>Visa på faktura:</b><br />
                <span class="angular-with-newlines">{{group?.TimeReportStatus?.DisplayName}}</span><br />
              </ng-container>
            </ng-template>

            <div *ngIf="group.TimeReportStatus.Name == 'SumTime'">
              {{group?.InvoiceRows[0]?.StartDate | swedishDate: 'yyyy-MM-dd'}} -
              {{group?.InvoiceRows[group.InvoiceRows.length-1]?.StartDate | swedishDate: 'yyyy-MM-dd'}} ({{getGroupTotalHours(group)}})
            </div>

            <div *ngIf="group.TimeReportStatus.Name == 'DetailedInfo'">
              <span *ngFor="let row of group.InvoiceRows; let i = index">
                {{row?.StartDate | swedishDate: 'yyyy-MM-dd'}} ({{row?.HoursWorked}} h{{row?.MinutesWorked > 0 ? ' ' + row?.MinutesWorked.toString() + ' min' : ''}}),
                <br *ngIf="i > 0 && (i + 1) % 4 == 0" />
              </span>
            </div>
            <div *ngIf="shouldShowHourlyRateDetails(group)">
              <b>Antal timmar, decimalform:</b><br />
              {{ getGroupTotalHoursDecimal(group) }}<br />
              <b>Genomsnittligt timpris:</b><br />
              {{ getGroupAverageHourlyRate(group) | number : '1.2-2' }} {{data?.Currency?.Name}}<br />
            </div>

            <div *ngIf="group.Deductions?.length > 0" class="deduction">
              <h4>Avdrag:</h4>
              <div *ngFor="let deduction of group.Deductions" class="deduction">
                <h4>{{deduction?.Name}}</h4>
                <b>Belopp enligt kvitto:</b><br />
                {{deduction?.Amount | number : '1.2-2'}} SEK<br />
                <ng-container *ngIf="deduction?.AddedToInvoice">
                  <b>Faktureras kund:</b><br />
                  {{(deduction?.AgreedInvoiceAmount != null ? deduction?.AgreedInvoiceAmount : deduction?.Amount) | number : '1.2-2'}} SEK<br />
                </ng-container>
                <b>Beskrivning:</b><br />
                <span class="angular-with-newlines">{{addLinebreaks(50, deduction?.Description)}}</span><br />
                  <div *ngIf="hasActiveWageGarnishment" class="row" style="margin-top: 10px;">
                    <div class="col-lg-4">
                      <div style="font-weight: 600;">Löneutmätning</div>
                    </div>
                    <div class="col-lg-8">
                      <mat-radio-group [ngModel]="deduction.IsGarnishable" (ngModelChange)="changeDeductionGarnishableStatus(deduction, $event)" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                        <mat-radio-button style="margin-right: 10px;" [value]="true">Utmätningsbar</mat-radio-button>
                        <mat-radio-button [value]="false">Ej utmätningsbar</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>



        <div>
          <div *ngFor="let deduction of data?.Deductions">
            <div style="border-style: solid; border-color: #b4b4b4; border-width: 1px; margin-bottom:15px; padding: 10px;" *ngIf="deduction.AddedToInvoice == true">
              <div style="display: inline-block;">
                <i>Avdrag</i>
                <h4>{{deduction?.Name}}</h4>
                <b>Belopp enligt kvitto:</b><br />
                {{deduction?.Amount | number : '1.2-2'}} SEK<br />
                <ng-container *ngIf="deduction?.AddedToInvoice">
                  <b>Faktureras kund:</b><br />
                  {{(deduction?.AgreedInvoiceAmount != null ? deduction?.AgreedInvoiceAmount : deduction?.Amount) | number : '1.2-2'}} SEK<br />
                </ng-container>
                <b>Beskrivning:</b><br />
                <span class="angular-with-newlines">{{addLinebreaks(50,deduction?.Description)}}</span>
                <div *ngIf="deduction?.HealthCare" class="col-lg-12"><i>Friskvårdsavdrag</i></div>
              </div>

            </div>
          </div>
        </div>

        <div>
          <div *ngIf="data.IsRot || data.IsRut">
            <div style="border-style: solid; border-color: #b4b4b4; border-width: 1px; margin-bottom:15px; padding: 10px;">
              <div style="display: inline-block;">
                <i></i>
                <h4>Framkörningsavgift</h4>
                <div>
                  <b>Moms:</b><br />
                  25 %<br />
                </div>
                <div *ngIf="data.IsRot">
                  <b>Fastighet/lägenhetsnr:</b><br />
                  {{data?.RotProperty}}<br />
                  <b>BRF orgnr:</b><br />
                  {{data?.BrfOrgNumber}}<br /><br />
                </div>
                <div>
                  <b>Summa:</b><br />
                  {{data?.RotDrivingFeeTotalAmount  | number : '1.2-2'}} SEK<br />
                </div>
                <div>
                  <b>Antal km:</b><br />
                  {{data?.RotDrivingFeeKm}} km<br />
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="data.IsRot || data.IsRut">
            <div style="border-style: solid; border-color: #b4b4b4; border-width: 1px; margin-bottom:15px; padding: 10px;">
              <div style="display: inline-block;">
                <h4>Totalt arbetade timmar på fakturan, decimalform:</h4>
                {{ getInvoiceTotalHoursDecimal() }}<br />
              </div>
            </div>
          </div>

          <div *ngIf="data.ParentInvoice">
            <div *ngFor="let vatSummary of data.VatSummaries" class="receiver" style="margin-bottom: 15px;">
              <div style="display: inline-block;">
                <i></i>
                <h4>Faktura enligt bifogad specifikation, {{ vatSummary.Vat }} % moms</h4>

                <b>Moms:</b><br />
                {{ vatSummary.Vat }} %<br />
                <b>Summa:</b><br />
                {{ vatSummary.TotalSum | number: '1.2-2' }} {{ data?.Currency?.Name }}
              </div>
            </div>
          </div>

          <div *ngIf="data.ParentInvoice && data?.ServiceFee > 0">
            <div class="receiver" style="margin-bottom: 15px;">
              <div style="display: inline-block;">
                <i></i>
                <h4>SAMekonomi-avgift uppdragsgivare</h4>

                <b>Moms:</b><br />
                25 %<br />
                <b>SAMekonomi-avgift</b><br />
                {{data?.ServiceFee}} SEK<br /><br />

                <b>Avsändarens SAMekonomi-avgift:</b><br />
                Procent på denna faktura: {{data?.ServiceFeeShare?.InvoiceSenderServiceFeeFactor * data?.ServiceFeeShare?.Percentage }} %<br />

                Avsändarens ordinarie SAMekonomi-avgift: {{data?.ServiceFeeShare?.InvoiceSenderServiceFeeFactor * 100 }} % <br />
                Angiven andel av ordinarie SE-avgift: {{data?.ServiceFeeShare?.Percentage }} % <br />

              </div>
            </div>
          </div>

          <div>
            <div *ngFor="let c of data?.Allowances">
              <div *ngIf="c.AddedToInvoice == true" style="border-style: solid; border-color: #b4b4b4; border-width: 1px; margin-bottom:15px; padding: 10px;">
                <i>Reseersättning</i>
                <h4>{{c.AllowanceType.Name}}</h4>
                <div *ngIf="c.Mileage == 0 || c.Mileage == null">
                  {{c.Sum  | number : '1.2-2' }} SEK <br />
                </div>
                <div *ngIf="c.Mileage > 0">
                  <div>{{ (c.CustomReimbursementPerKm !== 0 && c.sumCustomReimbursementPerKm ? c.sumCustomReimbursementPerKm : c.Sum) | number : '1.2-2' }} SEK</div>
                  <div>{{c.Mileage}} km</div><br />
                  <div>Fakturerad ersättning: {{c.CustomReimbursementPerKm}} SEK/km</div>

                  <!--<div style="font-style: italic;">(Skattefri reseersättning: {{c.Sum  | number : '1.2-2' }} SEK)</div><br />-->
                </div>
              </div>
              <div class="d-flex justify-content-start">
                <!--<button [disabled]="downloading" mat-raised-button color="accent" (click)="downloadTravelReport(data.InvoiceNumber)" style="margin: 25px 25px; margin: 10px 10px; margin-bottom: 30px;"><mat-icon>print</mat-icon> &nbsp; Skapa PDF</button>
          <mat-spinner *ngIf="downloading" [diameter]="30" style="margin-top: 10px;" color="accent"></mat-spinner>-->
              </div>
            </div>
          </div>
        </div>

        <hr *ngIf="data.ParentInvoice" />
        <div class="d-flex justify-content-start" *ngIf="data.ParentInvoice">
          <button [disabled]="downloading" mat-raised-button color="accent" (click)="downloadParentInvoiceInfoReport(data.InvoiceNumber)" style="margin: 25px 25px; margin: 10px 10px;"><mat-icon>print</mat-icon> &nbsp; Skapa PDF ersättningsmottagare</button>
          <mat-spinner *ngIf="activePdfReport === 'parent'" [diameter]="30" style="margin-top: 10px;" color="accent"></mat-spinner>
        </div>
        <div *ngIf="completedPdfReport === 'parent' && !downloading" role="status" style="margin: 0 10px 10px;"><mat-icon aria-hidden="true" style="vertical-align: middle;">check_circle</mat-icon> PDF klar &ndash; nedladdningen har startats.</div>

        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
          <mat-label>Fakturaavgift på faktura?</mat-label>
          <span *ngIf="data?.FeePaidByReciever"><input matInput readonly value="{{data?.InvoiceFee}}"></span>
          <span *ngIf="!data?.FeePaidByReciever"><input matInput readonly value="0"></span>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12" *ngIf="organizationSender == 1">
          <mat-label>Avsändaren registrerad för moms?</mat-label>
          <input matInput readonly value="{{data?.UserSettings?.FTax ? 'Ja' : 'Nej'}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12" style="margin-top: 20px;" *ngIf="organizationSender && data.ParentInvoice">
          <mat-label>Provision på fakturan (%)</mat-label>
          <input matInput readonly value="{{data?.Commission * 100  | number : '1.0-1'}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12" style="margin-top: 20px;" *ngIf="data?.PensionSavingsFactor > 0">
          <mat-label>Tjänstepension på fakturan (%)</mat-label>
          <input matInput readonly value="{{data?.PensionSavingsFactor * 100 | number : '1.0-1'}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-3 col-sm-12" style="margin-top: 20px;" *ngIf="data?.PensionSavingsAmount > 0">
          <mat-label>Tjänstepension (SEK)</mat-label>
          <input matInput readonly value="{{data?.PensionSavingsAmount  | number : '1.0-1'}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-3 col-sm-12" style="margin-top: 20px;" *ngIf="data?.PensionSavingsAmount > 0">
          <mat-label>Tjänstepension inkl skatt (SEK)</mat-label>
          <input matInput readonly value="{{data?.PensionSavingsAmount * 1.2426 | number : '1.0-0'}}">
        </mat-form-field>

        <div class="col-12">
          <h4 *ngIf="data.Documents.length > 0">Fakturabilagor</h4>
          <div *ngFor="let doc of data.Documents">
            <div *ngIf="doc.FileType.TechnicalName == 'AttachedInvoiceDocument'" class="row col-12" style="margin-bottom: 10px;">
              <div class="col-lg-4">
                <a color="secondary" (click)="showFile(doc)" style="cursor: pointer;">
                  <mat-icon style="position: relative; top: 7px; margin-right: 10px;">picture_as_pdf</mat-icon> {{doc?.Name}}
                </a>
              </div>
              <div class="col-lg-2">
                <button mat-icon-button color="primary" [disabled]="isLoading" (click)="deleteDocumentFromList(doc,data.Documents)"><mat-icon>delete</mat-icon></button>
              </div>
            </div>
          </div>
        </div>

        <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12" style="margin-top: 20px;">
          <mat-label>Totalsumma för hela fakturan ex moms:</mat-label>
          <input matInput readonly value="{{data?.TotalInvoiceAmount  | number : '1.2-2'}} {{data?.Currency?.Name}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12">
          <mat-label>Leveransmetod till kund:</mat-label>
          <input matInput readonly value="{{getSendTypeName(data.InvoiceSendType)}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
          <mat-label>E-postadress faktura:</mat-label>
          <input matInput readonly value="{{data?.RecieverEmail}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
          <mat-label>E-postadress fakturakopia:</mat-label>
          <input matInput readonly value="{{data?.RecieverEmailCopy}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
          <mat-label>Särskild e-post för påminnelser:</mat-label>
          <input matInput readonly value="{{data?.RecieverEmailReminder}}">
        </mat-form-field>

        <div class="col-12">
          <h4>Meddelanden till SAMpoolen :</h4>
          <div *ngFor="let m of data.Messages" class="angular-with-newlines">
            <i>({{m.Created | swedishDate: 'yyyy-MM-dd'}})</i>&nbsp;<b>{{m.CreatedBy}}:</b> <br />
            {{m.Text}}
          </div>
        </div>

        <div class="col-lg-12 col-sm-12" style="margin-top:20px; padding: 0px !important;">
          <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
            <mat-label>Fakturanummer</mat-label>
            <input type="text" [(ngModel)]="data.InvoiceNumber" matInput />
          </mat-form-field>

          <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
            <mat-label>OCR</mat-label>
            <input type="text" [(ngModel)]="data.Ocr" matInput />
          </mat-form-field>

          <div *ngIf="data.Currency.Name != 'SEK'">
            <mat-form-field floatLabel="always" class="col-6">
              <mat-label>Valutakurs</mat-label>
              <input type="number" [(ngModel)]="data.ExchangeRateInvoiceSent" matInput />
            </mat-form-field>
          </div>

          <mat-form-field floatLabel="always" class="col-6">
            <mat-label>Fakturan skickad av medlem</mat-label>
            <input matInput required [matDatepicker]="picker" [value]="data.InvoiceSentByUser" (dateChange)="data.InvoiceSentByUser = toFormattedDate($event.value)" id="InvoiceSentByUser" name="InvoiceSentByUser">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <mat-form-field floatLabel="always" class="col-6">
            <mat-label>Förfallodatum</mat-label>
            <input matInput [matDatepicker]="pickerPaymentDue" [value]="data.PaymentDue" (dateChange)="data.PaymentDue = toFormattedDate($event.value)" id="pickerPaymentDue" name="pickerPaymentDue">
            <mat-datepicker-toggle matSuffix [for]="pickerPaymentDue"></mat-datepicker-toggle>
            <mat-datepicker #pickerPaymentDue></mat-datepicker>
          </mat-form-field>

          <div class="row" style="margin-left:15px;margin-top:15px;padding-bottom:5px;">

            <div class="sp-form-field-label" style="width: 100%;"><h4>Fakturadokument:</h4></div>

            <div class="col-lg-6" style="margin-left: 0; padding-left: 0;">

              <button mat-raised-button color="accent" *ngIf="data?.InvoiceDocument?.Guid || data?.InvoiceDocument?.Url" (click)="showDocument(data.InvoiceDocument)" style="margin-left:2px;">Visa faktura: {{data?.InvoiceDocument?.Name}}</button>

              <button mat-stroked-button *ngIf="data?.InvoiceDocument?.Guid || data?.InvoiceDocument?.Url" (click)="clearInvoiceDocument()" style="margin-left:5px;margin-right:5px;">Radera</button>

              <input *ngIf="!data?.InvoiceDocument?.Guid && !data?.InvoiceDocument?.Url" type="file" mat-stroked-button mat-raised-button (change)="uploadFile($event,data.InvoiceDocument,'SentInvoice')" accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif">

            </div>

            <div class="col-lg-2">
              <button mat-raised-button color="accent"
                      [disabled]="!sendValidates(data)"
                      (click)="sendNotificationToUser(data.InvoiceDocument, data.Id)">
                <mat-icon>send</mat-icon> Skicka
              </button>
            </div>

            <div class="col-lg-4 error">
              <div *ngIf="data.Type?.TechnicalName == 'ProformaSubInvoice' || data.Type?.TechnicalName == 'ProformaSingleInvoice'">Detta är en proforma-faktura</div>
              <div *ngIf="data.Status?.TechnicalName == 'OfferingRequested'">Offert begärd</div>
              <div *ngIf="data.RecieverEmail == null || data.RecieverEmail == ''">Epost till mottagaren saknas</div>
              <div *ngIf="data.InvoiceSendType != 1">Annat leveranssätt är valt</div>
            </div>
          </div>
          <!--<div class="d-flex justify-content-start">
      <button [disabled]="downloading" mat-raised-button color="accent" (click)="downloadDeductionsReport(data.InvoiceNumber)" style="margin: 25px 25px; margin: 10px 10px;"><mat-icon>print</mat-icon> &nbsp; Skapa PDF vidarefakturerade nettoersättningar</button>
      <mat-spinner *ngIf="downloading" [diameter]="30" style="margin-top: 10px;" color="accent"></mat-spinner>
    </div>-->

          <hr />

          <div style="margin-bottom: 20px;">
            <div class="sp-form-field-label"><h4>Ladda upp övriga PDF-dokument</h4></div>
            <input [disabled]="isLoading" type="file" mat-stroked-button mat-raised-button (change)="uploadDocument($event,data.Documents)" accept=".pdf">
          </div>

          <!-- Document library -->
          <h4 *ngIf="data.Documents.length > 0">Övriga dokument</h4>
          <div *ngFor="let doc of data.Documents">
            <div *ngIf="doc.FileType.TechnicalName != 'AttachedInvoiceDocument'" class="row col-12" style="margin-bottom: 10px;">
              <div class="col-lg-4">
                <a color="secondary" (click)="showFile(doc)" style="cursor: pointer;">
                  <mat-icon style="position: relative; top: 7px; margin-right: 10px;">picture_as_pdf</mat-icon> {{doc?.Name}}
                </a>
              </div>
              <div class="col-lg-4">
                <mat-form-field floatLabel="always">
                  <mat-label>Dokumenttyp</mat-label>
                  <mat-select [name]="'filetypes-' + doc.Guid" [ngModel]="doc?.FileType?.Id" (ngModelChange)="documentTypeOnChange(doc, $event)" required>
                    <mat-option *ngFor="let c of fileTypes" [value]="c.Id">
                      {{ c.Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-2">
                <button mat-raised-button color="accent" [disabled]="isLoading || !sendDocumentByEmailValidation(doc.FileType, data.RecieverEmail, data.Reference.Email, data.RecieverEmailReminder)" (click)="sendNotificationToUser(doc,data.Id)"><mat-icon>send</mat-icon> Skicka</button>
                <div class="error">{{sendDocumentByEmailErrorMessage}}</div>
              </div>
              <div class="col-lg-2">
                <button mat-icon-button color="primary" [disabled]="isLoading" (click)="deleteDocumentFromList(doc,data.Documents)"><mat-icon>delete</mat-icon></button>
              </div>
            </div>
          </div>

          <!-- Log messages -->
          <h4 *ngIf="data.Log.length > 0">Händelselogg ({{data?.Log?.length}})</h4>
          <div *ngFor="let log of data.Log">
            <div class="row col-12" style="margin-bottom: 10px;">
              <div class="col-lg-3">
                <span color="secondary" style="cursor: pointer;">
                  {{log?.Created | swedishDate:'yyyy-MM-dd (HH:mm)'}}
                </span>
              </div>
              <div class="col-lg-9">
                <span style="font-size:12px;">{{log?.Message}}</span>
              </div>
            </div>
          </div>

          <hr />

          <div>
            <button mat-raised-button color="primary" (click)="close(data)" [disabled]="isLoading" style="float:left; margin-right: 10px;">Stäng</button>
            <button *ngIf="data?.ParentInvoice || data.SalaryShares.length > 0" mat-raised-button color="accent" (click)="saveAndClose(data)" [disabled]="!canSaveAndClose(data)" style="float:right; margin-right: 10px;">Spara och skapa underfakturor</button>
            <button *ngIf="!data?.ParentInvoice && data.SalaryShares.length == 0" mat-raised-button color="accent" (click)="saveAndClose(data)" [disabled]="!canSaveAndClose(data)" style="float:right; margin-right: 10px;">Spara </button>
            <button mat-raised-button (click)="save(data)" [disabled]="isLoading" style="float:right; margin-right: 10px;">Spara vy</button>
          </div>


        </div>
        <mat-form-field floatLabel="always" class="col-lg-12 col-sm-12" style="margin-top: 13px;">
          <mat-label>Medlemsnummer:</mat-label>
          <input matInput readonly value="{{data?.UserSettings?.MemberNumber}}">
        </mat-form-field>

        <div *ngIf="data.ExpressPayOut && !ContactEmailApprovedForExpress" class="col-lg-12 col-sm-12">
          <span class="error">Observera epost-domänen</span>
        </div>

        <div *ngIf="!data.ParentInvoice" class="col-lg-12 col-sm-12">
          <mat-label>Expressutbetalning vald (klicka i boxen för att ändra): </mat-label>
          <mat-checkbox [(ngModel)]="data.ExpressPayOut" style="margin-left:15px;">
            <div *ngIf="data.ExpressPayOut">
              Ja
            </div>
            <div *ngIf="!data.ExpressPayOut">
              Nej
            </div>
          </mat-checkbox>
        </div>

        <div *ngIf="data.ParentInvoice" class="col-lg-12 col-sm-12">
          <mat-label>Bekräftad av fakturamottagare (express av underfakturor kan godkännas): </mat-label>
          <mat-checkbox [(ngModel)]="data.ApprovedForExpress" style="margin-left:15px;">
            <div *ngIf="data.ApprovedForExpress">
              Ja
            </div>
            <div *ngIf="!data.ApprovedForExpress">
              Nej
            </div>
          </mat-checkbox>
        </div>

        <div *ngIf="!data.ParentInvoice && !data.SubInvoice" class="col-lg-12 col-sm-12">
          <mat-label>Fakturan godkänd för expressutbetalning: </mat-label>
          <mat-checkbox [(ngModel)]="data.ApprovedForExpress" style="margin-left:15px;">
            <div *ngIf="data.ApprovedForExpress">
              Ja
            </div>
            <div *ngIf="!data.ApprovedForExpress">
              Nej
            </div>
          </mat-checkbox>
        </div>

        <div *ngIf="data.SalaryShares != null && data.SalaryShares.length > 0" class="col-12">
          <b>Lönedelning:</b><br />
          <div *ngFor="let share of data.SalaryShares">
            <div>Personnummer: {{ share?.SalaryReciever?.PersonalNumber }}</div>
            <div>{{ share?.Share != null && share?.Share > 0 ? 'Delning: ' + share.Share + ' %' : '' }}</div>
            <div>{{ share?.Salary != null && share?.Salary > 0 ? 'Delning bruttolön: ' + share.Salary + ' kr' : '' }}</div>
          </div>
        </div>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12" style="margin-top: 20px;">
          <mat-label>E-postadress referensperson:</mat-label>
          <input matInput readonly value="{{data?.Reference?.Email}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
          <mat-label>Telefon referensperson:</mat-label>
          <input matInput readonly value="{{data?.Reference?.Phone}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
          <mat-label>Fakturareferens:</mat-label>
          <input matInput readonly value="{{data?.ReferenceText}}">
        </mat-form-field>
        <mat-form-field floatLabel="always" class="col-lg-6 col-sm-12">
          <mat-label>Kampanjkod:</mat-label>
          <input matInput readonly value="{{data?.UserSettings?.DiscountCode}}">
        </mat-form-field>

        <div class="col-12 receiver">
          <b>Summa avdrag:</b><br />
          {{DeductionsTotal | number : '1.2-2'}} SEK

          <ng-container *ngFor="let deduction of data?.Deductions">
            <div class="border">
              <div style="display: block; width: 100%; margin-bottom: 15px;">
                <div style="display: flex; justify-content: flex-end; width: 100%;">
                  <span style="font-size: 80%;">{{deduction?.AddedToInvoice ? 'Fakturerat till kund' : (data?.SubInvoice ? 'Läggs inte till separat på underfakturan' : 'Ej fakturerat till kund')}}</span>
                </div>
                <ng-container *ngIf="deduction?.Name">
                  <h4>{{deduction.Name}}</h4><br />
                </ng-container>
              <h4>Beskrivning:</h4>
              <span class="angular-with-newlines">{{addLinebreaks(50,deduction?.Description)}}</span><br /><br />
              <b>Skattefritt utlägg:</b><br />
              {{deduction.Amount  | number : '1.2-2'}} SEK<br />
              <ng-container *ngIf="deduction?.AddedToInvoice">
                <b>Faktureras kund:</b><br />
                {{(deduction?.AgreedInvoiceAmount != null ? deduction?.AgreedInvoiceAmount : deduction?.Amount) | number : '1.2-2'}} SEK<br />
              </ng-container>
              <ng-container *ngIf="data?.SubInvoice && !deduction?.AddedToInvoice && deduction?.AgreedInvoiceAmount != null">
                <b>Sparat avtalat fakturabelopp:</b><br />
                {{deduction.AgreedInvoiceAmount | number : '1.2-2'}} SEK<br />
              </ng-container><br />
              <div *ngIf="deduction?.HealthCare">Friskvårdsavdrag</div>


            </div>
            <div class="row">
              <div class="col-lg-6">
                <a *ngIf="deduction.Attachment?.Guid || deduction.Attachment?.Url" mat-stroked-button color="secondary" (click)="showFile(deduction.Attachment)"><mat-icon>open_in_new</mat-icon>&nbsp; Visa dokument</a>&nbsp;
                <a *ngIf="deduction.AttachmentReciept?.Guid || deduction.AttachmentReciept?.Url" mat-stroked-button color="secondary" (click)="showFile(deduction.AttachmentReciept)"><mat-icon>open_in_new</mat-icon>&nbsp; Visa kvittens</a>&nbsp;
                </div>
              <div class="col-lg-8">
                <mat-radio-group [(ngModel)]="deduction.status" (change)="changeDeductionStatus(deduction, $event.value); calculateDeductionTotalAmount()" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                  <mat-radio-button style="margin-right: 10px;" value="underReview">Granskas</mat-radio-button>
                  <mat-radio-button style="margin-right: 10px;" value="approved">Utlägg godkänt</mat-radio-button>
                  <mat-radio-button value="denied">Utlägg ej godkänt</mat-radio-button>
                </mat-radio-group>
              </div>
              <div *ngIf="hasActiveWageGarnishment" class="col-lg-12" style="margin-top: 10px;">
                <div class="row">
                  <div class="col-lg-4">
                    <div style="font-weight: 600;">Löneutmätning</div>
                  </div>
                  <div class="col-lg-8">
                    <mat-radio-group [ngModel]="deduction.IsGarnishable" (ngModelChange)="changeDeductionGarnishableStatus(deduction, $event)" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                      <mat-radio-button style="margin-right: 10px;" [value]="true">Utmätningsbar</mat-radio-button>
                      <mat-radio-button [value]="false">Ej utmätningsbar</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="sp-form-field-label" style="margin-top: 10px;">Kommentar som syns för medlem:</div>
                <input [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0" type="text" style="margin: 10px 0; padding: 5px; border: 1px solid lightgrey; width: 100%;" [(ngModel)]="deduction.DeniedReason" matInput />
                <div *ngIf="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0" style="margin: 10px 0; font-style: italic;">
                  Denna faktura är redan delad, och underlaget finns i underfakturan tillhörande {{data?.UserSettings?.FirstName}} {{data?.UserSettings?.LastName}}. Om informationen om detta avdrag är felaktig måste detta ändras där.
                </div>
              </div>
              </div>
            </div>
          </ng-container>
          <div class="save-button-container">
            <button color="accent" mat-raised-button (click)="save(data)" [disabled]="isLoading">Spara vy</button>
          </div>
        </div>


        <div>
          <div class="d-flex justify-content-between align-items-center" style="width: 100%; margin-bottom: 8px;">
            <h4>Reseersättning</h4>
            <button mat-stroked-button color="primary" (click)="approveAllAllowances()">Godkänn alla reseersättningar</button>
          </div>
          <div *ngIf="sumMileage != 0">Summa milersättning: {{sumMileage}}</div>
          <div *ngIf="sumMileage != 0">Antal km: {{mileageDistance}}</div>
          <div *ngIf="sumDomesticAllowance != 0">Summa traktamente, inrikes: {{sumDomesticAllowance}}</div>
          <div *ngIf="sumInternationalAllowance != 0">Summa traktamente, utrikes: {{sumInternationalAllowance}}</div>
          <div *ngFor="let c of data?.Allowances" class="deduction">
            <div style="font-weight: bold;">{{c.AllowanceType.Name}}</div>
            <div>{{c.Sum  | number : '1.2-2' }} SEK</div>
            <br />
            <div *ngIf="c.AllowanceType.Id == 1">
              <div>{{c.Mileage}} km</div>
              <br />
              <div><strong>Resväg:</strong> {{c.TravelStart}}<ng-container *ngFor="let viaStop of c.ViaStops"> - {{viaStop}}</ng-container> - {{c.TravelEnd}}</div>
              <div><strong>Anledning:</strong> {{c.ReasonForTravel}}</div>
              <br />
            </div>
            <div *ngIf="c.AllowanceType.Id == 2">
              <div>{{c.Destination}}</div>
              <div>
                {{c.TravelDateStart | swedishDate: 'yyyy-MM-dd'}} - {{c.TravelDateEnd | swedishDate: 'yyyy-MM-dd'}}<br />
                (Heldagar: {{c.FullDays}}, halvdagar: {{c.HalfDays}})
              </div><br />
              <div><strong>Anledning:</strong> {{c.ReasonForTravel}}</div>
            </div>
            <div *ngIf="c.AllowanceType.Id == 3">
              <div>{{c.CountryId}} - {{c.Destination}}</div>
              <div>
                {{c.TravelDateStart | swedishDate: 'yyyy-MM-dd'}} - {{c.TravelDateEnd | swedishDate: 'yyyy-MM-dd'}}<br />
                (Heldagar: {{c.FullDays}}, halvdagar: {{c.HalfDays}})
              </div><br />
              <div><strong>Anledning:</strong> {{c.ReasonForTravel}}</div>

              <br />
            </div>
            <div class="row">
              <div class="col-lg-12">
                <mat-radio-group [(ngModel)]="c.status" (change)="changeAllowanceStatus(c, $event.value)" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                  <mat-radio-button style="margin-right: 10px;" value="underReview">Granskas</mat-radio-button>
                  <mat-radio-button style="margin-right: 10px;" value="approved">Reseersättning godkänd</mat-radio-button>
                  <mat-radio-button value="denied">Reseersättning ej godkänd</mat-radio-button>
                </mat-radio-group>
              </div>
              <div *ngIf="hasActiveWageGarnishment" class="col-lg-12" style="margin-top: 10px;">
                <div class="row">
                  <div class="col-lg-4">
                    <div style="font-weight: 600;">Loneutmatning</div>
                  </div>
                  <div class="col-lg-8">
                    <mat-radio-group [ngModel]="c.IsGarnishable" (ngModelChange)="changeAllowanceGarnishableStatus(c, $event)" [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0">
                      <mat-radio-button style="margin-right: 10px;" [value]="true">Utmatningsbar</mat-radio-button>
                      <mat-radio-button [value]="false">Ej utmatningsbar</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="sp-form-field-label" style="margin-top: 10px;">Kommentar som syns för medlem:</div>
                <input [disabled]="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0" type="text" style="margin: 10px 0; padding: 5px; border: 1px solid lightgrey; width: 100%;" [(ngModel)]="c.DeniedReason" matInput />
                <div *ngIf="data.Status.TechnicalName != 'UnderReview' && data.SalaryShares != null && data.SalaryShares.length > 0" style="margin: 10px 0; font-style: italic;">
                  Denna faktura är redan delad, och underlaget finns i underfakturan tillhörande {{data?.UserSettings?.FirstName}} {{data?.UserSettings?.LastName}}. Om informationen om denna reseersättning är felaktig måste detta ändras där.
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center" style="width: 100%;">
            <div>
              <button style="margin: 25px 25px; margin: 10px 10px; margin-bottom: 30px;" [disabled]="downloading" mat-raised-button color="accent" (click)="downloadTravelReport(data.InvoiceNumber)"><mat-icon>print</mat-icon> &nbsp; Skapa PDF reseersättningar</button>
              <mat-spinner *ngIf="activePdfReport === 'travel'" [diameter]="30" style="margin-top: 10px;" color="accent"></mat-spinner>
            </div>
            <div>
              <button style="margin: 25px 25px; margin: 10px 10px; margin-bottom: 30px;" color="accent" mat-raised-button (click)="save(data)" [disabled]="isLoading">Spara vy</button>
            </div>
          </div>
          <div *ngIf="completedPdfReport === 'travel' && !downloading" role="status" style="margin: 0 10px 10px;"><mat-icon aria-hidden="true" style="vertical-align: middle;">check_circle</mat-icon> PDF klar &ndash; nedladdningen har startats.</div>

        </div>
      </div>
    </div>
  </div>
</div>
